import { Box } from "@mui/material";
import { usePolicyOutletContext } from "../hooks/usePolicyOutletContext";

export function PolicyPropertiesTab() {
  const { policy, policyId } = usePolicyOutletContext();

  return (
    <Box>
      <pre>{`
TODO: Implement policy properties tab
      `}</pre>
    </Box>
  );
}
